import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivitiesResponse, Activity } from './activity.interface';
import { ExportParams } from './export-params.interface';
import { Filters, FiltersDto } from './filters.interface';

export abstract class TollingRepository {
    abstract getList(page: number, pageSize: number, filtersDto: FiltersDto): Observable<ActivitiesResponse>;
    abstract getDetail(activityId: string): Observable<Activity>;
    abstract getFilters(filtersDto: FiltersDto): Observable<Filters>;
    abstract exportToCsv(params: ExportParams): Observable<HttpResponse<Blob>>;
}
